export default __webpack_public_path__ + "static/media/may-2019-us.87afb319.csv";